import { render, staticRenderFns } from "./ListBadges.vue?vue&type=template&id=4f3574a6&scoped=true"
import script from "./ListBadges.vue?vue&type=script&lang=js"
export * from "./ListBadges.vue?vue&type=script&lang=js"
import style0 from "./ListBadges.vue?vue&type=style&index=0&id=4f3574a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3574a6",
  null
  
)

export default component.exports